import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_ENCOUNTERS_REQUEST, fetchEncountersSuccess, fetchEncountersFailure,
  CREATE_ENCOUNTER_REQUEST, createEncounterSuccess, createEncounterFailure,
  UPDATE_ENCOUNTER_REQUEST, updateEncounterSuccess, updateEncounterFailure,
  DELETE_ENCOUNTER_REQUEST, deleteEncounterSuccess, deleteEncounterFailure
} from '../actions/encounterActions';
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = getBaseUrl();
const authToken = localStorage.getItem('authToken');
const getAuthToken = () => localStorage.getItem('authToken');

const createConfig = () => ({
  headers: { 'Authorization': `Bearer ${authToken}` }
});

function* fetchEncounters(action) {
  try {
    const token = getAuthToken();
    const { projectId, page = 1, limit = 2, search = '', group = '' } = action.payload || {};

    console.log("Fetching encounter data with payload: ", { projectId, page, limit, search, group });

    const baseUrl = getBaseUrl();

    const response = yield call(
      axios.get,
      `${baseUrl}/${projectId}/encounter`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params: { page, limit, search, group },
      }
    );

    // Assuming response structure includes `data` and `meta`
    yield put(fetchEncountersSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.message || "An unknown error occurred";
    console.error("Error fetching encounter data: ", errorMessage);
    yield put(fetchEncountersFailure(errorMessage));
  }
}

function* createEncounter(action) {
  try {
    const response = yield call(axios.post, `${API_BASE_URL}/${action.payload.projectId}/encounter`, action.payload.data, createConfig());
    yield put(createEncounterSuccess(response.data));
  } catch (error) {
    yield put(createEncounterFailure(error.message));
  }
}

function* updateEncounter(action) {
  try {
    const { id, data,projectId } = action.payload;
    const response = yield call(axios.put, `${API_BASE_URL}/${projectId}/encounter/${id}`, data, createConfig());
    yield put(updateEncounterSuccess(response.data));
  } catch (error) {
    yield put(updateEncounterFailure(error.message));
  }
}

function* deleteEncounter(action) {
  try {
    const { id,projectId } = action.payload;
    yield call(axios.delete, `${API_BASE_URL}/${projectId}/encounter/${id}`, createConfig());
    yield put(deleteEncounterSuccess(id));
  } catch (error) {
    yield put(deleteEncounterFailure(error.message));
  }
}

export default function* encounterSaga() {
  yield takeLatest(FETCH_ENCOUNTERS_REQUEST, fetchEncounters);
  yield takeLatest(CREATE_ENCOUNTER_REQUEST, createEncounter);
  yield takeLatest(UPDATE_ENCOUNTER_REQUEST, updateEncounter);
  yield takeLatest(DELETE_ENCOUNTER_REQUEST, deleteEncounter);
}
